export const spindlInit = () => {}

export const spindlAttribute = (_address: string) => {}
